import { defineStore } from 'pinia'
import {
  OneNetworkStoreContextActionType
} from '@/onenetwork/constants/onenetwork.constant.action_type'

export const useSiteContextStore = defineStore('onenetwork.site_context', {
  state: (): any => ({
    site: null,
    fetching: false,
    error: null,
    actionType: OneNetworkStoreContextActionType.FETCHING,
    fcmToken: null,
  }),

  getters: {

  },

  actions: {
    setFcmToken(token: string) {
      this.fcmToken = token
    }
  }
})
